import { render, staticRenderFns } from "./LeGameCalendarEvent.vue?vue&type=template&id=5e37db28"
import script from "./LeGameCalendarEvent.vue?vue&type=script&lang=js"
export * from "./LeGameCalendarEvent.vue?vue&type=script&lang=js"
import style0 from "./LeGameCalendarEvent.vue?vue&type=style&index=0&id=5e37db28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports